import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { endLoading } from '../../../actions/loadingAction';
import { Button, Chips } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { configs, isNullOrEmpty, labelsPlant, newObjArray, showMessageToast, showMessageToastCustom, translate } from '../../../utils/util';
import ModalCimPalletQuantity from './CimPallet/ModalCimPalletQuantity';
import ReceiptListItem from './ReceiptListItem';

const ReceiptList = (props) => {
  const [receipts, setReceipt] = useState([]);
  const [receiptPartNumber, setReceiptPartNumber] = useState();
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [filterShed, setShed] = useState([]);
  const [filterPlant, setPlant] = useState([]);
  const [almoxList, setAlmoxList] = useState([]);
  const [config, setConfig] = useState({});
  let massiveItems = [];
  let visualItems = [];

  useEffect(() => {
    const configItem = configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items);
    setConfig(configItem);
    props.hideLoading();
    document.addEventListener("filterReceiptBai", filterReceiptBai);

    return () => {
      document.removeEventListener("filterReceiptBai", filterReceiptBai);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let dataFilter = newObjArray(props.receipts)
    setReceipt(dataFilter);
    setReceiptFilter(props.receipts);
    if ((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && !config.shedRequiredPhysicalConfirmation) {
      if (filterShed) {
        var selectedShed = filterShed.find((itemF) => itemF.select === true);
        if (selectedShed) {
          filterReceiptShed(selectedShed.shed);
        }
      }
    } else {
      var selectedAlmox = almoxList.find((itemF) => itemF.select === true);
      if (selectedAlmox) {
        filterReceiptAlmox(selectedAlmox.almox);
      }

      var array = [];
      if (dataFilter) {
        dataFilter.forEach(element => {
          var data = {
            key: `${element.companyId}-${element.warehouseId}`,
            text: labelsPlant(`${element.companyId}-${element.warehouseId}`),
            selected: false
          };

          if (!array.find(f => f.key === data.key)) {
            array.push(data);
          }
        });
      }

      setPlant(array)
    }
    // eslint-disable-next-line
  }, [props.receipts]);

  useEffect(() => {
    if (receiptPartNumber) {
      setOpenModalConfirm(true);
    }
  }, [receiptPartNumber]);

  const selectFilterAux = (shed) => {
    let list = newObjArray(filterShed)
    let shedFilter = "";
    list.forEach(element => {
      if (element.shed === shed) {
        element.select = element.select ? false : true;
      }
      else {
        element.select = false;
      }

      if (element.select) {
        shedFilter = element.shed;
      }
    });

    setShed(list);
    filterReceiptShed(shedFilter);
  }

  const selectFilterAlmox = (almox) => {
    let list = newObjArray(almoxList);
    let almoxFilter = "";
    list.forEach(element => {
      if (element.almox === almox) {
        element.select = element.select ? false : true;
      }
      else {
        element.select = false;
      }

      if (element.select) {
        almoxFilter = element.almox;
      }
    });

    if (props.receiptsCimPallet) {
      props.receiptsCimPallet.forEach(item => {
        props.removedReceiptCimPallet(item);
      });
    }

    setAlmoxList(list);
    filterReceiptAlmox(almoxFilter);
  }

  const filterReceiptBai = (event) => {
    var baiCode = document.getElementById("baiCodeFilter")?.value
    let dataFilter = newObjArray(event.detail.data);
    if (!isNullOrEmpty(baiCode)) {
      dataFilter = dataFilter.filter((item) => item.baiCode === baiCode);
    }
    setReceipt(dataFilter);
  }

  const filterReceiptShed = (shedFilter) => {
    let dataFilter = newObjArray(props.receipts);
    if (!isNullOrEmpty(shedFilter)) {
      dataFilter = dataFilter.filter((item) => item.shed === shedFilter);
    }
    setReceipt(dataFilter);
  }

  const filterReceiptAlmox = (almox) => {
    let dataFilter = newObjArray(props.receipts);
    if (!isNullOrEmpty(almox)) {
      dataFilter = dataFilter.filter((item) => item.almox === almox);
    }
    setReceipt(dataFilter);
  }

  const filterplant = (plant) => {
    let dataFilter = [];
    if (!isNullOrEmpty(plant)) {
      filterPlant.forEach(element => {
        if (element.key === plant) {
          element.selected = element.selected ? false : true
        }
      });
      setPlant([...filterPlant]);
      dataFilter = filterPlant.filter(f => f.selected).length > 0 ? props.receipts.filter((item) => `${item.companyId}-${item.warehouseId}` === plant) : props.receipts;
      props.resetReceipsCimPallet();
      props.resetReceipsGroup();
    }
    setReceipt([...dataFilter]);
  }

  const setReceiptFilter = (data) => {
    if (data) {
      if ((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && !config.shedRequiredPhysicalConfirmation) {
        data.forEach((item) => {
          if (!isNullOrEmpty(item.shed) && !filterShed.find((itemF) => itemF.shed === item.shed)) {
            filterShed.push({
              shed: item.shed,
              select: false
            });
          }
        })
        setShed(filterShed.sort((a, b) => (a.shed > b.shed) ? 1 : ((b.shed > a.shed) ? -1 : 0)));
      } else {
        let list = [];

        data.forEach((item) => {
          if (!isNullOrEmpty(item.almox) && !list.find((itemF) => itemF.almox === item.almox) && !list.find((i) => i.almox === item.almox)) {
            var selectedAlmox = almoxList.find((f) => f.select === true)?.almox;

            list.push({
              almox: item.almox,
              select: item.almox === selectedAlmox
            });
          }
        })
        setAlmoxList([...list]);
      }
    }
  }

  const validItemStatus = (item) => {
    if (item.status === ENUMS.eReceiptStatus.Anomaly.value || item.status === ENUMS.eReceiptStatus.Wait.value) {
      showMessageToast({ html: "Pendencia Contábil, procurar time SHARED SERVICES", classes: 'red' });
      return false;
    }

    return true;
  }

  const onSeletedItemChange = (item) => {
    if (!props.group && validItemStatus(item)) {
      props.createConfirmation(item, '', item.mdr);
      props.onSelectedItemChange(false);
    }
  };

  const isMassiveValid = () => {
    massiveItems = receipts.filter(r => r.massiveReceiptIndicator && r.balance > 0);
    visualItems = receipts.filter(r => r.visualReceiptIndicator && r.balance > 0);
    var cimPallets = props.receiptsCimPallet.filter(r => r.balance > 0);
    if (massiveItems.length === 0 && cimPallets.length === 0 && visualItems === 0) {
      return showMessageToastCustom(translate('warning', 'general'), translate("no-items-selected-for-receipt", "general"), 8000, 'mdi mdi-alert-circle-outline red-text');
    }
    redirectToMassive();
  }

  const redirectToMassive = () => {
    var selectedAlmox = almoxList.find((f) => f.select === true)?.almox;
    props.history.push({
      pathname: `./massiveReceipt`,
      state: {
        almox: selectedAlmox,
        baiFilter: document.getElementById("baiCodeFilter")?.value,
        truckKanban: props.filter.truckKanban
      },
      ...props
    });
  }

  const addListReceiptGroup = (element) => {
    for (let index = 0; index < element.pallets; index += 1) {
      props.addReceiptCimPallet(element);
      props.updateMassiveItem(element.id, false);
      props.updateVisualIndicator(element.id, false);
    }
  }

  const onSetGroupeItem = (item) => {
    if (props.receiptsCimPallet.find(f => f.id === item.id)) {
      props.removedReceiptCimPallet(item);
    } else {
      setReceiptPartNumber(item);
      setOpenModalConfirm(true);
    }
  }

  return receipts?.length > 0 ? (
    <div id={props.id || 'i.receipts'} className="row" style={{ marginBottom: '5px' }}>
      {((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && !config.shedRequiredPhysicalConfirmation && !props.filter.truckKanban) ?
        filterShed.length > 0 && (
          <div className="container" style={{ paddingTop: 50, paddingRight: 0, paddingLeft: 0 }}>
            <Chips onClick={selectFilterAux} array={filterShed.map((i) => {
              return { key: i.shed, text: i.shed, selected: i.select };
            })
            } />
          </div>
        )
        :
        !props.filter.truckKanban && almoxList.length > 0 && (
          <div className="container" style={{ paddingTop: 50, paddingRight: 0, paddingLeft: 0 }}>
            <Chips
              onClick={selectFilterAlmox}
              array={almoxList.map((i) => { return { key: i.almox, text: i.almox, selected: i.select }; })}
            />
          </div>
        )
      }
      {
        props.filter.truckKanban && filterPlant.length > 1 &&
        <div className="container" style={{ paddingTop: '2px', paddingBlockEnd: '10px' }}>
          <Chips
            onClick={filterplant}
            array={filterPlant}
          />
        </div>
      }
      <ul className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0 }}>
        {
          receipts.map((item, index) => {
            return <ReceiptListItem
              {...props}
              group={props.group}
              key={`ri-${index}`}
              config={config}
              data={item}
              index={index}
              truckKanban={props.filter.truckKanban}
              onSetMasterCim={props.onSetMasterCim}
              onSetCimPallet={onSetGroupeItem}
              onSelectedItemChange={onSeletedItemChange} />
          })
        }
      </ul>
      <div className="row" style={{ marginBottom: '5px' }}>
        <div className="col s12 lefth">
          {
            (receipts.filter(r => r.massiveReceiptIndicator).length > 0 ||
              receipts.filter(r => r.visualReceiptIndicator).length > 0 ||
              props.receiptsCimPallet.length > 0) && (!props.group || !props.packList) &&
            (<Button onClick={isMassiveValid} full="true" text={translate('general:massive-receipt')} />)
          }
        </div>
      </div>
      <ModalCimPalletQuantity
        open={openModalConfirm}
        receipt={receiptPartNumber}
        id="ModalCimPalletQuantity"
        content={translate('physical-confirmation:confirm-cim-pallet')}
        dismissible={false}
        onCancel={() => { setOpenModalConfirm(false); setReceiptPartNumber(null) }}
        onClose={() => { setOpenModalConfirm(false); setReceiptPartNumber(null) }}
        onConfirm={(evt) => addListReceiptGroup(evt)} />
    </div>
  ) : null;
}

const mapStateToProps = (state) => {
  return {
    filter: state.physicalConfirmationReducer.filter,
    confirmations: state.physicalConfirmationReducer.transmissions,
    user: state.userReducer.user,
    config: state.configReducer.config,
    sheds: state.configReducer.sheds,
    receiptsCimPallet: state.physicalConfirmationReducer.receiptsCimPallet
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createConfirmation: (receiptItem, quantity, mdrType) => {
      dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
    },
    addReceiptCimPallet: (receipt) => {
      dispatch(PhysicalConfirmationService.addReceiptCimPallet(receipt));
    },
    removedReceiptCimPallet: (receipt) => {
      dispatch(PhysicalConfirmationService.removedReceiptCimPallet(receipt));
    },
    updateMassiveItem: (id, value) => {
      dispatch(PhysicalConfirmationService.updateMassiveIndicator(id, value));
    },
    updateVisualIndicator: (id, value) => {
      dispatch(PhysicalConfirmationService.updateVisualIndicator(id, value));
    },
    resetReceipsGroup: () => {
      dispatch(PhysicalConfirmationService.resetReceipsGroup());
    },
    resetReceipsCimPallet: () => {
      dispatch(PhysicalConfirmationService.resetReceipsCimPallet());
    },
    hideLoading: () => {
      dispatch(endLoading());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptList));